/* src/app/components/footer/footer.component.scss */
/*# sourceMappingURL=footer.component.css.map */
